/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormikErrors, FormikTouched } from 'formik';

export const errorsToTouch = <T>(errors: FormikErrors<T>): FormikTouched<T> => {
    const touched: any = {};
    Object.keys(errors).forEach(key => {
        const value = (errors as any)[key];
        if (value === null || value === undefined) {
            return;
        }

        if (typeof value === 'string') {
            touched[key] = true;
        } else {
            touched[key] = errorsToTouch(value);
        }
    });

    return touched;
};
